import type { FetchBaseQueryError } from '@reduxjs/toolkit/query';

export const extractErrorMessage = (
  error: FetchBaseQueryError | undefined | null
): string => {
  if (
    !error ||
    !error.data ||
    typeof error.data !== 'object' ||
    !('error' in error.data)
  ) {
    return '';
  }
  return error.data.error as string;
};
